import Radio from './src/radio';

/* istanbul ignore next */
Radio.install = function(Vue) {
  Vue.component('zk-radio', Radio);
};

export default Radio;



// WEBPACK FOOTER //
// ./src/packages/radio/index.js